export default "__VITE_ASSET__Djg$1A82__"